import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, RequireAuth } from './lib/auth';
import PublicLayout from './components/layout/PublicLayout';
import Home from './pages/Home';
import Models from './pages/Models';
import ModelDetail from './pages/ModelDetail';
import Demo from './pages/Demo';
import { HowItWorks, About, Help, Methodology, Privacy, Terms } from './pages/Content';
import CustomModels from './pages/CustomModels';
import { Login, Signup, ResetPassword } from './pages/auth/AuthPages';
import AuthCallback from './pages/auth/AuthCallback';
import Dashboard from './pages/app/Dashboard';
import NewModel from './pages/app/NewModel';
import Workspace from './pages/app/Workspace';
import Settings from './pages/app/Settings';
import Admin from './pages/app/Admin';
import NotFound from './pages/NotFound';
import { ErrorBoundary } from './components/layout/ErrorBoundary';

export default function App() {
  return <ErrorBoundary><AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/models" element={<Models />} />
          <Route path="/models/:slug" element={<ModelDetail />} />
          <Route path="/demo/:slug" element={<Demo />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about" element={<About />} />
          <Route path="/custom-models" element={<CustomModels />} />
          <Route path="/report-issue" element={<CustomModels issue />} />
          <Route path="/help" element={<Help />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/app" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/app/models/new" element={<RequireAuth><NewModel /></RequireAuth>} />
          <Route path="/app/settings" element={<RequireAuth><Settings /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth admin><Admin /></RequireAuth>} />
        </Route>
        <Route path="/app/models/:id" element={<RequireAuth><Workspace /></RequireAuth>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  </AuthProvider></ErrorBoundary>;
}
